import get from 'lodash/get';
import { PAYMENT_ACTIONS as PA } from '../../../constants';

/**
 * Fields permissions
 */
const permissions = {
  intermediary: {
    payment: {
      Domestic: [PA.VALIDATE_PAYMENT, PA.MODIFY_PAYMENT],
      International: [PA.VALIDATE_PAYMENT, PA.MODIFY_PAYMENT]
    },
    template: {
      Domestic: [PA.CREATE_TEMPLATE, PA.MODIFY_TEMPLATE],
      International: [PA.CREATE_TEMPLATE, PA.MODIFY_TEMPLATE]
    }
  }
};

/**
 * Api keys in preferences, that we are matching against.
 */
const apiPrefs = {
  intermediary: {
    template: 'freeFormIntermediaryBankTempl'
  }
};

/**
 * Get permissions for specific field, based on specific criteria.
 *
 * @param {object} preferences those are coming from api
 * @param {string} action based on this one we are getting variant (template, payment)
 * @param {string} type field type we want to get permissions for (intermediary only for now)
 * @param {string} wirePaymentType type of payment (Domestic, International)
 */
// eslint-disable-next-line import/prefer-default-export
export const getPermissions = ({
  action,
  formState,
  isTemplate,
  paymentTypes,
  preferences,
  type
}) => {
  try {
    const variant = action.replace(/[a-zA-Z]+-/g, '');
    const pref = apiPrefs[type][variant];
    const perm = permissions[type][variant];
    const source = isTemplate ? paymentTypes : paymentTypes.map((x) => x.child);
    const dataset = isTemplate ? source : [].concat.apply(...source);
    const wirePaymentType = get(
      dataset.find(
        (c) =>
          c[isTemplate ? 'paymentType' : 'name'] ===
          get(
            formState,
            `paymentType.0.${isTemplate ? 'type' : 'name'}`,
            get(formState, 'paymentType')
          )
      ),
      isTemplate ? 'paymentType' : 'type'
    );
    const instance = (wirePaymentType && perm && perm[wirePaymentType]) || [];

    return {
      intermediary: instance.includes(action) && get(preferences, `${pref}.${wirePaymentType}`)
    };
  } catch (e) {
    // User doesn't have freeform permissions
    return {};
  }
};
